module.exports = __webpack_public_path__ + "static/img/statistics_overview_gray.19a1268.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statistics_overview_gray.svg
// module id = B7vI
// module chunks = 1